import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';

const inlineStyles = () => ({
  heading: {
    fontWeight: '400',
    margin: '15px 0 10px',
  },
  button: {
    marginTop: 20,
  },
});

/**
 * Cta
 * @param {Object} classes     Classes from JSS inlineStyles
 * @param {Object} headline
 * @param {Object} caption
 * @param {Object} buttonCaption
 * @param {Object} image
 */

const Cta = ({ classes, headline, caption, image, buttonCaption, buttonUrl }) => {
  return (
    <article className={classes.paddingLeftRight}>
      <img src={image} alt={headline} />
      <Typography variant="h4" color="primary" className={classes.heading}>
        {headline}
      </Typography>
      <Typography variant="body2">{caption}</Typography>
      <Button variant="outlined" target="_blank" href={buttonUrl} className={classes.button}>
        {buttonCaption}
      </Button>
    </article>
  );
};

Cta.propTypes = {
  classes: PropTypes.object,
  headline: PropTypes.string,
  caption: PropTypes.string,
  image: PropTypes.string,
  buttonCaption: PropTypes.string,
  buttonUrl: PropTypes.string,
};

Cta.defaultProps = {
  classes: {},
  headline: '',
  caption: '',
  image: '',
  buttonCaption: '',
  buttonUrl: '',
};

export default withStyles(inlineStyles)(withTranslation('translations')(Cta));
